import React from "react";
import PropTypes from "prop-types";
import { TD, TR } from "./BusinessDashboard/Table/Table";

const LeadSourceRow = ({ source, isOtherSource }) => (
  <TR>
    <TD>{isOtherSource ? source.other_source : source.source}</TD>
    <TD>{isOtherSource ? source.other_new : source.new}</TD>
    <TD>{isOtherSource ? source.other_unqualified : source.unqualified}</TD>
    <TD>{isOtherSource ? source.other_watch : source.watch}</TD>
    <TD>{isOtherSource ? source.other_nurture : source.nurture}</TD>
    <TD>{isOtherSource ? source.other_hot : source.hot}</TD>
    <TD>{isOtherSource ? source.other_past : source.past}</TD>
    <TD>{isOtherSource ? source.other_inactive : source.inactive}</TD>
    <TD>{isOtherSource ? source.other_archived : source.archived}</TD>
    <TD>{isOtherSource ? source.other_trash : source.trash}</TD>
    <TD>
      <strong>{isOtherSource ? source.other_total_leads : source.total_leads}</strong>
    </TD>
  </TR>
);

LeadSourceRow.propTypes = {
  source: PropTypes.shape().isRequired,
  isOtherSource: PropTypes.bool.isRequired,
};

export default LeadSourceRow;
